<template>
  <section class="mt-7" data-testid="cockpit-cqi-section">
    <h2 class="cockpit-section-title">
      {{ $t('UserProjects.cockpit.sections.cqiTrend') }}
    </h2>

    <div class="grid grid-cols-1 md:grid-cols-4 gap-4 mb-4">
      <CockpitResultCard
        :label="$t('UserProjects.cockpit.kpi.cqiThisWeek')"
        :value="cqiLabel"
        :ampel-dot="cqiAmpel"
        :prev-value="prevLabel"
        :delta-value="deltaLabel"
        :n-value="currentN"
        :n-label="$t('UserProjects.cockpit.kpi.reflections')"
        test-id="cockpit-kpi-cqi"
      />
    </div>

    <div class="cockpit-panel">
      <CockpitCqiTrendChart :bars="chartBars" />
    </div>
  </section>
</template>

<script>
import CockpitResultCard from './CockpitResultCard.vue';
import CockpitCqiTrendChart from './CockpitCqiTrendChart.vue';
import {
  formatPpcDelta,
  resolvePpcAmpelHex,
} from '@/utils/cockpitDisplay';

export default {
  name: 'CockpitCqiSection',
  components: { CockpitResultCard, CockpitCqiTrendChart },
  props: {
    current: { type: Object, default: null },
    chartBars: { type: Array, default: () => [] },
    thresholds: { type: Object, default: () => ({ greenMin: 70, yellowMin: 50 }) },
  },
  computed: {
    currentN() {
      return this.current?.n ?? 0;
    },
    cqiValue() {
      return typeof this.current?.cqi === 'number' ? this.current.cqi : null;
    },
    cqiLabel() {
      return this.cqiValue === null ? '—' : String(this.cqiValue);
    },
    cqiAmpel() {
      return resolvePpcAmpelHex(this.cqiValue, this.thresholds);
    },
    prevLabel() {
      const delta = this.current?.deltaVsPrevious;
      if (delta === null || delta === undefined) return null;
      const prev = this.cqiValue === null ? null : this.cqiValue - Number(delta);
      if (prev === null || Number.isNaN(prev)) return null;
      return this.$t('UserProjects.cockpit.prevWeek', { value: `${Math.round(prev)}` });
    },
    deltaLabel() {
      return formatPpcDelta(this.current?.deltaVsPrevious);
    },
  },
};
</script>

<style scoped>
.cockpit-section-title {
  margin: 0 0 0.75rem;
  font-size: 13px;
  color: #ababab;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  font-weight: 500;
}

.cockpit-panel {
  background: #fff;
  border-radius: 12px;
  padding: 1.25rem;
  border: 1px solid #e5e5e5;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}
</style>
